// Initial state for TV shows
const initialState = {
    tvShows: [],
    loading: false,
    error: null,
};

// Action types
const FETCH_TV_REQUEST = 'FETCH_TV_REQUEST';
const FETCH_TV_SUCCESS = 'FETCH_TV_SUCCESS';
const FETCH_TV_FAILURE = 'FETCH_TV_FAILURE';

// Reducer function
const tvReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TV_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_TV_SUCCESS:
            return {
                ...state,
                loading: false,
                tvShows: action.payload,
            };
        case FETCH_TV_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default tvReducer;
